import { Badge } from 'reactstrap';

export interface MenuBadgeProps {
  count: number;
  title: string;
}

/**
 * SP-8a — Badge numerico accanto alle voci di menu (top-bar orizzontale).
 * Hidden quando count <= 0. Mostra "99+" per count > 99.
 *
 * Rinominato da SidebarBadge → MenuBadge (la sidebar verticale è stata
 * rimossa in SP-8a; le voci ora vivono nell'header).
 */
export function MenuBadge({ count, title }: MenuBadgeProps) {
  // Difesa runtime: useFulfilledCount talvolta restituisce l'oggetto
  // by_status invece del solo `fulfilled` (regressione SP-8a/dashboard-kpi).
  // Forziamo a int per evitare il "[object Object]" nel badge.
  const n = typeof count === 'number' && Number.isFinite(count) ? Math.floor(count) : 0;
  if (n <= 0) return null;
  const display = n > 99 ? '99+' : String(n);
  return (
    <Badge color="warning" pill className="ms-1" title={title}>
      {display}
    </Badge>
  );
}
